import axios from 'axios';
import { baseUrl } from '@/config';

export default {
  /**
   * [성능/운영 > 무선 장비 맵] AP 컨트롤러에 대한 무선 장비 맵 데이터 조회
   * @author jeee12
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getApControllerMapData(params) {
    return axios.post(`${baseUrl}/performance/wireless-device-map/get-ap-controller-map-data.do`, params);
  },
  /**
   * [성능/운영 > 무선 장비 맵] 무선 AP에 대한 무선 장비 맵 데이터 조회
   * @author jeee12
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getWirelessApMapData(params) {
    return axios.post(`${baseUrl}/performance/wireless-device-map/get-wireless-ap-map-data.do`, params);
  },
};



// WEBPACK FOOTER //
// ./src/api/performance/wireless-device-map/wireless-device-map.js